import {Paper, Typography} from '@mui/material';
import {QuizTimedMode} from '@cp/model';

export interface SessionNavigationHelpProps {
  timedMode: QuizTimedMode;
}

export default function SessionNavigationHelp({timedMode}: SessionNavigationHelpProps) {
  const getNavigationHelpText = () => {
    if (timedMode === QuizTimedMode.TIMED_PER_QUESTION) {
      return 'Sequential mode: Navigate through questions in order. You cannot go back to previous questions.';
    }
    return 'Free navigation mode: Use the navigation buttons to move between questions. You can review and change answers before submitting.';
  };

  return (
    <Paper sx={{p: 2, bgcolor: 'grey.50'}}>
      <Typography variant="body2" color="text.secondary" sx={{textAlign: 'center'}}>
        {getNavigationHelpText()}
      </Typography>
    </Paper>
  );
}
